import { Step, StepId, StepType } from "@redotech/redo-return-ui/flows/step";
import { createStepFromType, generateStepId } from "./create-step";
import { dragTypeMatchesTitle, FlowEditorDragType } from "./step-type-registry";

export interface DropResult {
  steps: Map<StepId, Step>;
  newStepId: StepId;
  position: { x: number; y: number };
}

export function snapToGrid(
  position: { x: number; y: number },
  gridSize: number,
): { x: number; y: number } {
  return {
    x: Math.round(position.x / gridSize) * gridSize,
    y: Math.round(position.y / gridSize) * gridSize,
  };
}

export function handleStepDropped({
  dragType,
  position,
  steps,
  stepOptions,
  gridSize = 20,
}: {
  dragType: FlowEditorDragType;
  position: { x: number; y: number };
  steps: Map<StepId, Step>;
  stepOptions: StepType<any, any>[];
  gridSize?: number;
}): DropResult | null {
  const stepType = stepOptions.find((st) =>
    dragTypeMatchesTitle(dragType, st.title),
  );

  if (!stepType) {
    console.error(`No step type found for drag type: ${dragType}`);
    return null;
  }

  const newStepId = generateStepId(steps);
  const newStep = createStepFromType(stepType, steps);
  const snappedPosition = snapToGrid(position, gridSize);

  const updatedSteps = new Map(steps);
  updatedSteps.set(newStepId, newStep);

  return { steps: updatedSteps, newStepId, position: snappedPosition };
}
